import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http'

const state: AuthorizationState = {
  keys: [],
}

const getters: GetterTree<AuthorizationState, RootState> = {

}

const actions: ActionTree<AuthorizationState, RootState> = {
  keys ({ commit }) {
    return http.v1.authz.keys().then((response) => {
      commit('SET_KEYS', response.data.data)
    })
  },
}

const mutations: MutationTree<AuthorizationState> = {
  SET_KEYS (state, keys) {
    state.keys = keys
    // state.businessKeys = groups.business_group
  },
}

const author: Module<AuthorizationState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default author